import React, { useRef } from "react";
import style from "css/workspace.module.css";
import Questions from "components/app/questions";
import { useMediaQuery } from "react-responsive";
import SEOMeta from "components/app/SEOMeta";
import Consult from "components/device/neat/consult";
import { FloatButton } from "antd";

function Platform(props) {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const priceRef = useRef(null);

  const handleClickFloatingBtn = () => {
    priceRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <>
      <SEOMeta
        title="스마트 워크 플랫폼 all Place, 리브테크놀로지"
        description="리브테크놀로지 riv Technology - 스마트 워크 플랫폼 all Place"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, 스마트 워크 플랫폼, all Place"
      />
      <div className={style.wrapper}>
        <button
          style={
            props?.type
              ? {
                  top:
                    !isMobile && !isTablet
                      ? "calc(10vh + 30px)"
                      : "calc(10vh + 10px)",
                  right: !isMobile && !isTablet ? "120px" : "70px",
                }
              : null
          }
          className={style.floating_btn}
          onClick={handleClickFloatingBtn}
        >
          <div className={style.floating_btn_wrap}>
            <img
              alt=""
              src={`${process.env.REACT_APP_CLIENT_URL}img/common/new.png`}
            />
            <div className={style.floating_btn_text}>
              <span>더 가벼워진</span>
              {"\n"}도입 비용 보기
            </div>
            <img
              alt=""
              src={`${process.env.REACT_APP_CLIENT_URL}img/common/down.png`}
            />
          </div>
        </button>
        <div className={style.commonHeader}>
          <div className={style.platformHeaderTxt}>
            <p>
              <font>포스트 코로나의 시대</font>
              <font>새로운 오피스의 기준</font>
            </p>
            <img
              alt=""
              src={`${process.env.REACT_APP_CLIENT_URL}img/common/allplace_logo_wh.png`}
            />
            <p>
              {!isMobile && !isTablet ? (
                <>
                  <font>
                    효율성은 높이면서 유지관리 비용은 절감하는 혁신적 업무
                    환경을 위한
                  </font>
                  <font>
                    리브 테크놀로지의 Hybrid Working System Platform, all
                    Place를 소개합니다.
                  </font>
                </>
              ) : (
                <>
                  <font>
                    효율성은 높이면서 유지관리 비용은{"\n"} 절감하는 혁신적 업무
                    환경을 위한 리브 테크놀로지의{"\n"} Hybrid Working System
                    Platform,{"\n"} all Place를 소개합니다.
                  </font>
                </>
              )}
            </p>
          </div>
          {!isMobile && !isTablet ? (
            <img
              className={style.platformHeaderImg}
              alt=""
              src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/platformHeader.png`}
            />
          ) : (
            <div className={style.platformHeaderImgWrap}>
              <img
                className={style.platformHeaderImg}
                alt=""
                src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/platformHeader_1_m.png`}
              />
              <img
                className={style.platformHeaderImg}
                alt=""
                src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/platformHeader_2_m.png`}
              />
            </div>
          )}

          <div className={style.platformHeader2}>
            <p>
              변화하는 시대에 맞춘{"\n"} 하이브리드 워킹시스템 플랫폼을 이용해
              보세요!
            </p>
            <p>회의실 예약 · 자율 좌석제{"\n"} · 화상회의 시스템</p>
            <div className={style.platformHeader2CardWrap}>
              <div>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/platformCardImg.png"
                  }
                />
                <font>
                  온 · 오프라인을 넘나들며,
                  <br /> <label>언제 어디서든</label> 근무 가능
                </font>
              </div>
              <div>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/platformCardImg2.png"
                  }
                />
                <font>
                  최적화된 사무공간으로
                  <br /> <label>임대비용 절감</label>
                </font>
              </div>
              <div>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/platformCardImg3.png"
                  }
                />
                <font>
                  공간의 혁신을 통한
                  <br /> <label>유연하고 창의적인 팀원과의 협업</label>
                </font>
              </div>
            </div>
          </div>
          <div className={style.platformHeader3}>
            <div className={style.txt}>
              <font>(주)리브테크놀로지를</font>
              <font>선택해야 하는 이유!</font>
            </div>
            <div className={style.cardWrap}>
              {!isMobile && !isTablet ? (
                <>
                  <div className={style.cardList}>
                    <div className={style.card2}>
                      <div className={style.card1Num}>01</div>
                      <div className={style.card2Txt}>
                        <font className={style.highlight}>회의실 시스템</font>
                        <font>단순 예약을 넘어선 스마트한 공간 관리</font>
                      </div>
                    </div>
                    <div className={style.card2}>
                      <div className={style.card1Num}>02</div>
                      <div className={style.card2Txt}>
                        <font className={style.highlight}>자율좌석 시스템</font>
                        <font>직관적이고 유연한 자율좌석 시스템</font>
                      </div>
                    </div>
                  </div>
                  <div className={style.cardList}>
                    <div className={style.card2}>
                      <div className={style.card1Num}>03</div>
                      <div className={style.card2Txt}>
                        <font className={style.highlight}>화상회의 시스템</font>
                        <font>공간과 완벽하게 통합되는 화상회의 환경</font>
                      </div>
                    </div>
                    <div className={style.card2}>
                      <div className={style.card1Num}>04</div>
                      <div className={style.card2Txt}>
                        <font>회의실과 좌석 사용 데이터를 통합 분석한</font>
                        <font>대시보드·통계 등 편의 기능 탑재</font>
                      </div>
                    </div>
                  </div>
                  <div className={style.card1}>
                    <div className={style.card1Line}>
                      <font className={style.card1Num}>05</font>
                      <div className={style.card1Txt}>
                        다양한 <span>전문 화상회의 플랫폼</span>과 연결가능
                      </div>
                    </div>
                    <div className={style.card1Line}>
                      <font className={style.card1Num2}>01</font>
                      <div className={style.cardImgList}>
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp1.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp2.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp3.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp4.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp5.png"
                          }
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className={style.card2}>
                    <div className={style.card1Num}>01</div>
                    <div className={style.card2Txt}>
                      <font className={style.highlight}>회의실 시스템</font>
                      <font>단순 예약을 넘어선 스마트한 공간 관리</font>
                    </div>
                  </div>
                  <div className={style.card2}>
                    <div className={style.card1Num}>02</div>
                    <div className={style.card2Txt}>
                      <font className={style.highlight}>자율좌석 시스템</font>
                      <font>직관적이고 유연한 자율좌석 시스템</font>
                    </div>
                  </div>
                  <div className={style.card2}>
                    <div className={style.card1Num}>03</div>
                    <div className={style.card2Txt}>
                      <font className={style.highlight}>화상회의 시스템</font>
                      <font>공간과 완벽하게 통합되는 화상회의 환경</font>
                    </div>
                  </div>
                  <div className={style.card2}>
                    <div className={style.card1Num}>04</div>
                    <div className={style.card2Txt}>
                      <font>회의실과 좌석 사용 데이터를 통합 분석한</font>
                      <font>대시보드·통계 등 편의 기능 탑재</font>
                    </div>
                  </div>
                  <div className={style.card1}>
                    <div className={style.card1Line}>
                      <font className={style.card1Num}>05</font>
                      <div className={style.card1Txt}>
                        다양한 <span>전문 화상회의 플랫폼</span>과 연결가능
                      </div>
                    </div>
                    <div className={style.card1Line}>
                      {/* <font className={style.card1Num2}>01</font> */}
                      <div className={style.cardImgList}>
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp1.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp2.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp3.png"
                          }
                        />
                      </div>
                      <div className={style.cardImgList}>
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp4.png"
                          }
                        />
                        <div />
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/platformComp5.png"
                          }
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <div className={style.platformHeader4}>
          <font>{"국내 유일\nAll-in-One 플랫폼"}</font>
          <font>
            all Place는 회의실 예약 및 영상회의,{"\n"} 자율좌석제 지정까지
            <br />
            포스트 코로나 시대의 업무환경을{"\n"} 관리해주고 참여할 수 있는
            사이트 입니다.
          </font>
          {!isTablet && !isMobile ? (
            <div className={style.imgBorderWrap}>
              <img
                alt=""
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/smartspace/platformSolution.png"
                }
              />
            </div>
          ) : (
            <img
              alt=""
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                "img/smartspace/platformSolution_m.png"
              }
            />
          )}
        </div>

        <div className={style.platformInfo}>
          <div className={style.InfoHeader}>
            <font>효율적인 관리와{"\n"} 직관적인 사용성</font>
            <font>
              메인페이지에서 전체 현황을 한눈에 파악하고,
              <br />
              마이페이지와 캘린더로 개인 스케줄과 예약을{"\n"} 손쉽게 관리할 수
              있습니다.
            </font>
          </div>

          <div className={style.platformWrap}>
            <div className={style.infoTxt}>
              <div className={style.infoTxtImg}>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/infotxt1.png"
                  }
                />
              </div>
              <p className={style.infoTxtTitle}>
                <font>Main Page</font> <span /> <font>메인 페이지</font>
              </p>
              <p className={style.infoTxtBody}>
                {!isMobile && !isTablet ? (
                  <font>
                    <label>
                      Hot Desking 예약부터 회의실 일정 확인까지,
                      <br />
                      한눈에 보는 스마트 예약 현황.
                    </label>
                    <br />
                    예약된 좌석과 회의실 정보를 달력과 타임라인으로 쉽게 확인할
                    수 있으며,
                    <br /> 부서별 좌석 현황도 실시간으로 확인 가능합니다.
                    <br /> 직관적인 인터페이스로 효율적인 공간 관리를
                    지원합니다.
                  </font>
                ) : (
                  <font>
                    <label>
                      Hot Desking 예약부터 회의실 일정 확인까지,
                      <br />
                      한눈에 보는 스마트 예약 현황.
                    </label>
                    <br />
                    예약된 좌석과 회의실 정보를 달력과 타임라인으로 쉽게 확인할
                    수 있으며, 부서별 좌석 현황도 실시간으로 확인 가능합니다.
                    직관적인 인터페이스로 효율적인 공간 관리를 지원합니다.
                  </font>
                )}
              </p>
            </div>
            <div className={style.infoImg}>
              <img
                alt=""
                src={
                  !isMobile && !isTablet
                    ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg1.png`
                    : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg1_m.png`
                }
              />
            </div>
          </div>

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg2.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg2_m.png`
                  }
                />
              </div>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt2.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>
                    Hot Desking
                    <br />
                    Reservation & Status
                  </font>{" "}
                  <font>자율좌석 예약 및 현황</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    사용자의 예약 이력을 바탕으로
                    <label> 추천 좌석을 제공</label>
                    하며,
                    <br />
                    확정된 좌석과 다양한 기능을 통해 업무 효율성을 극대화할 수
                    있습니다.
                    <br />
                    <label>손쉬운 좌석 선택과 체계적인 예약 관리</label>를 통해
                    더 유연하고 스마트한
                    <br />
                    업무 환경을 경험해 보세요.
                  </font>
                </p>
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt2.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>
                    Hot Desking
                    <br />
                    Reservation & Status
                  </font>{" "}
                  <font>자율좌석 예약 및 현황</font>
                </p>
                <p className={style.infoTxtBody}>
                  {!isMobile && !isTablet ? (
                    <font>
                      사용자의 예약 이력을 바탕으로
                      <label> 추천 좌석을 제공</label>
                      하며,
                      <br />
                      확정된 좌석과 다양한 기능을 통해 업무 효율성을 극대화할 수
                      있습니다.
                      <br />
                      <label>손쉬운 좌석 선택과 체계적인 예약 관리</label>를
                      통해 더 유연하고 스마트한
                      <br />
                      업무 환경을 경험해 보세요.
                    </font>
                  ) : (
                    <font>
                      사용자의 예약 이력을 바탕으로
                      <label> 추천 좌석을 제공</label>
                      하며, 확정된 좌석과 다양한 기능을 통해 업무 효율성을
                      극대화할 수 있습니다.
                      <br />
                      <label>손쉬운 좌석 선택과 체계적인 예약 관리</label>를
                      통해 더 유연하고 스마트한 업무 환경을 경험해 보세요.
                    </font>
                  )}
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg2.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg2_m.png`
                  }
                />
              </div>
            </div>
          )}

          <div className={style.platformWrap}>
            <div className={style.infoTxt}>
              <div className={style.infoTxtImg}>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/infotxt3.png"
                  }
                />
              </div>
              <p className={style.infoTxtTitle}>
                <font>조감도</font>
                {/* <font>자율좌석 동료현황</font> */}
              </p>
              <p className={style.infoTxtBody}>
                {!isMobile && !isTablet ? (
                  <font>
                    <label>건물별,층별 사무실 조감도를 제공</label>하여
                    <br />
                    좌석및 회의실의 <label>위치를 확인하고</label>
                    <br />
                    직관적으로 <label>쉽게 예약</label>할 수 있습니다.
                    <br />
                    <br />
                    <br />※ Web, Mobile, Kiosk 버전을 모두 제공합니다.
                  </font>
                ) : (
                  <font>
                    <label>건물별,층별 사무실 조감도를 제공</label>하여 좌석및
                    회의실의 <label>위치를 확인하고</label>
                    직관적으로 <label>쉽게 예약</label>할 수 있습니다.
                    <br /> <br />※ Web, Mobile, Kiosk 버전을 모두 제공합니다.
                  </font>
                )}
              </p>
            </div>
            <div className={style.infoImg}>
              <img
                alt=""
                src={
                  !isMobile && !isTablet
                    ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg3.png`
                    : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg3_m.png`
                }
              />
            </div>
          </div>

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg4.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg4_m.png`
                  }
                />
              </div>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt4.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Hot Desking Colleague Status</font>
                  <font>자율좌석 동료현황</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    <label>나의 좌석 정보</label>를 손쉽게 공유하고,{" "}
                    <label>동료의 현재 접속 여부</label> 및<br />
                    <label>근무 상태</label>
                    를 한눈에 확인할 수 있습니다.
                    <br />
                    팀원 간 빠른 위치 파악과 소통을 통해 협업 효율을 높여보세요.
                  </font>
                </p>
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt4.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Hot Desking Colleague Status</font>
                  <font>자율좌석 동료현황</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    <label>나의 좌석 정보</label>를 손쉽게 공유하고,{" "}
                    <label>
                      동료의 현재 접속
                      <br />
                      여부
                    </label>{" "}
                    및 <label>근무 상태</label>를 한눈에 확인할 수 있습니다.
                    <br />
                    팀원 간 빠른 위치 파악과 소통을 통해 협업 효율을 높여보세요.
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg4.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg4_m.png`
                  }
                />
              </div>
            </div>
          )}

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt5.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Meeting Room Overview</font> <font>회의실 현황</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    모든 회의실 현황을 한눈에 확인할 수 있습니다.
                    <br />
                    일반회의실과 화상회의실 현황을 확인하여 원하는 회의를 쉽고
                    편리하게
                    <br />
                    예약할 수 있습니다.
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg5.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg5_m.png`
                  }
                />
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt5.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Meeting Room Overview</font> <font>회의실 현황</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    모든 회의실 현황을 한눈에 확인할 수 있습니다.
                    <br />
                    일반회의실과 화상회의실 현황을 확인하여 원하는 회의를 쉽고
                    편리하게 예약할 수 있습니다.
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg5.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg5_m.png`
                  }
                />
              </div>
            </div>
          )}

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg6.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg6_m.png`
                  }
                />
              </div>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt6.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Calendar</font>
                  <font>회의예약 스케줄링 캘린더</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    하나의 캘린더로 일정 / 회의실 및 단말예약이 모두 가능합니다.
                    <br />
                    Drag & Drop 으로 손쉽게 예약 및 관리를 할 수 있으며,
                    <br />
                    사용자가 편리하게 이용할 수 있도록 주간 / 월간 캘린더형식을
                    제공합니다.
                  </font>
                </p>
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/infotxt6.png"
                    }
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Calendar</font>
                  <font>회의예약 스케줄링 캘린더</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    하나의 캘린더로 일정 / 회의실 및 단말예약이 모두 가능합니다.
                    <br />
                    Drag & Drop 으로 손쉽게 예약 및 관리를 할 수 있으며,
                    <br />
                    사용자가 편리하게 이용할 수 있도록 주간 / 월간 캘린더형식을
                    제공합니다.
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg6.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg6_m.png`
                  }
                />
              </div>
            </div>
          )}

          <div className={style.platformWrap}>
            <div className={style.infoTxt}>
              <div className={style.infoTxtImg}>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/infotxt7.png"
                  }
                />
              </div>
              <p className={style.infoTxtTitle}>
                <font>Multi-Platform</font> <font>멀티플랫폼 지원</font>
              </p>
              <p className={style.infoTxtBody}>
                {!isMobile && !isTablet ? (
                  <font>
                    예약화면에서 멀티플랫폼 모두를 자유롭게 사용하실 수 있어
                    <br />
                    다양하고 유연하게 화상회의를 개설하고 참여할 수 있습니다.
                  </font>
                ) : (
                  <font>
                    예약화면에서 멀티플랫폼 모두를 자유롭게 사용하실 수 있어
                    다양하고 유연하게 화상회의를 개설하고 참여할 수 있습니다.
                  </font>
                )}
              </p>
            </div>
            <div className={style.infoImg}>
              <img
                alt=""
                src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg7_m.png`}
              />
            </div>
          </div>

          {!isMobile && !isTablet ? (
            <div className={style.platformWrap}>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg8.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg8_m.png`
                  }
                />
              </div>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/infotxt8.png`}
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Dashboard</font>
                  <font>대시보드 제공</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    다양한 형태의 대시보드를 제공합니다.
                    <br />
                    출장비 (Off-line) 절감 금액에 대한 데이터도 제공 받을 수
                    있습니다.
                  </font>
                </p>
              </div>
            </div>
          ) : (
            <div className={style.platformWrap}>
              <div className={style.infoTxt2}>
                <div className={style.infoTxtImg}>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/infotxt8.png`}
                  />
                </div>
                <p className={style.infoTxtTitle}>
                  <font>Dashboard</font>
                  <font>대시보드 제공</font>
                </p>
                <p className={style.infoTxtBody}>
                  <font>
                    다양한 형태의 대시보드를 제공합니다.
                    <br />
                    출장비 (Off-line) 절감 금액에 대한 데이터도 제공 받을 수
                    있습니다.
                  </font>
                </p>
              </div>
              <div className={style.infoImg}>
                <img
                  alt=""
                  src={
                    !isMobile && !isTablet
                      ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg8.png`
                      : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/infoImg8_m.png`
                  }
                />
              </div>
            </div>
          )}

          <div ref={priceRef} />
          <div
            className={style.introduction_method_area}
            // ref={priceRef}
          >
            <div className={style.introduction_method_title_wrap}>
              <div className={style.introduction_method_label}>
                구독형 이용요금
              </div>
              <div className={style.introduction_method_title}>
                <span>회의실 예약</span>부터 <span>자율좌석제</span> 도입까지,
                {"\n"}
                회사에 필요한 <span>기능만</span> 사용하는
                {isMobile || isTablet ? "\n" : null} 모듈형 구독 서비스
              </div>
            </div>
            <div className={style.introduction_method_contents}>
              <div className={style.introduction_method_box}>
                <div className={style.introduction_method_item_title}>
                  Standard
                </div>
                <div className={style.introduction_system_wrapper}>
                  <div className={style.introduction_system_box}>
                    <div className={style.introduction_system_box_header}>
                      <div className={style.introduction_system_box_title_wrap}>
                        <img
                          alt=""
                          src={`${process.env.REACT_APP_CLIENT_URL}img/common/allplace_logo_wh.png`}
                        />
                        <div className={style.introduction_system_box_title}>
                          회의실 시스템
                        </div>
                      </div>
                      <div
                        className={style.introduction_system_box_description}
                      >
                        <span>대기업</span>이 사용하는 효율적인 회의 공간 관리
                        시스템을 저렴하게
                      </div>
                    </div>
                    <div className={style.introduction_system_box_body}>
                      <div className={style.introduction_system_price}>
                        <div className={style.introduction_system_price_value}>
                          25,000원
                        </div>
                        <div className={style.introduction_system_price_label}>
                          회의실 1개 / 월 이용료
                        </div>
                      </div>
                      <div className={style.introduction_system_built_in}>
                        기본 제공 : Wall Pad 연동 포함
                      </div>
                    </div>
                    <div className={style.introduction_system_option_list}>
                      <div className={style.introduction_system_option_item}>
                        <span
                          className={style.introduction_system_option_item_spot}
                        />
                        <span>추가옵션 : </span>Wall Pad 장비 구매 및 설치비
                        별도{"\n"}(별도 문의)
                      </div>
                      <div className={style.introduction_system_option_item}>
                        <span
                          className={style.introduction_system_option_item_spot}
                        />
                        <span>할인 정책 : </span> 규모 및 약정 기간에 따른 할인
                        적용{"\n"}(별도 문의)
                      </div>
                    </div>
                  </div>
                  <div className={style.introduction_system_box}>
                    <div className={style.introduction_system_box_header}>
                      <div className={style.introduction_system_box_title_wrap}>
                        <img
                          alt=""
                          src={`${process.env.REACT_APP_CLIENT_URL}img/common/allplace_logo_wh.png`}
                        />
                        <div className={style.introduction_system_box_title}>
                          자율좌석 시스템
                        </div>
                      </div>
                      <div
                        className={style.introduction_system_box_description}
                      >
                        <span>카카오, 네이버</span> 등 빅테크 기업처럼 유연한
                        조직 문화를 위한 최적의 업무공간 시스템
                      </div>
                    </div>
                    <div className={style.introduction_system_box_body}>
                      <div className={style.introduction_system_price}>
                        <div className={style.introduction_system_price_value}>
                          2,000원
                        </div>
                        <div className={style.introduction_system_price_label}>
                          좌석 1개 / 월 이용료
                        </div>
                      </div>
                      <div className={style.introduction_system_built_in}>
                        기본 제공 : 도면 1개 층 UI 무상 제공
                      </div>
                    </div>
                    <div className={style.introduction_system_option_list}>
                      <div className={style.introduction_system_option_item}>
                        <span
                          className={style.introduction_system_option_item_spot}
                        />
                        <span>추가옵션 : </span>전자명패 장비 구매 및 설치비
                        별도 (별도 문의)
                      </div>
                      <div className={style.introduction_system_option_item}>
                        <span
                          className={style.introduction_system_option_item_spot}
                        />
                        <span>할인 정책 : </span> 규모 및 약정 기간에 따른 할인
                        적용 (별도 문의)
                      </div>
                    </div>
                  </div>
                </div>
                <div className={style.introduction_system_feature}>
                  <div className={style.introduction_system_feature_label}>
                    핵심 기능
                  </div>
                  <div className={style.introduction_system_feature_list}>
                    <div className={style.introduction_system_feature_item}>
                      구글 · 아웃룩 캘린더 연동
                    </div>
                    <div className={style.introduction_system_feature_item}>
                      캘린더 기반 예약
                    </div>
                    <div className={style.introduction_system_feature_item}>
                      회상회의 연동 (Zoom)
                    </div>
                    <div className={style.introduction_system_feature_item}>
                      기본 예약 현황판
                    </div>
                    <div className={style.introduction_system_feature_item}>
                      노쇼 방지 기능
                    </div>
                    <div className={style.introduction_system_feature_item}>
                      별도 앱 설치 없이 PC / Mobile 즉시 예약
                    </div>
                    <div className={style.introduction_system_feature_item}>
                      좌석 배치도 커스텀
                    </div>
                    <div className={style.introduction_system_feature_item}>
                      이용 데이터 시각화 대시보드
                    </div>
                  </div>
                </div>
              </div>
              <div className={style.introduction_method_box}>
                <div className={style.introduction_method_item_title}>
                  Enterprise
                </div>
                <div className={style.introduction_enterprise_price}>
                  <div className={style.introduction_enterprise_price_label}>
                    고객 맞춤 상담
                  </div>
                  <div className={style.introduction_enterprise_feature_box}>
                    <div className={style.introduction_standard_feature}>
                      Standard 핵심 기능
                    </div>
                    <div
                      className={style.introduction_enterprise_plus_icon_box}
                    >
                      +
                    </div>
                    <div className={style.introduction_enterprise_feature}>
                      <div
                        className={style.introduction_enterprise_feature_label}
                      >
                        Enterprise 추가 기능
                      </div>
                      <div
                        className={style.introduction_enterprise_feature_list}
                      >
                        <div
                          className={style.introduction_enterprise_feature_item}
                        >
                          사전 도입 점검 : 현장 컨설팅 제공
                        </div>
                        <div
                          className={style.introduction_enterprise_feature_item}
                        >
                          인사 시스템 (ERP / AD) 연동
                        </div>
                        <div
                          className={style.introduction_enterprise_feature_item}
                        >
                          AI 공간 최적화 리포트
                        </div>
                        <div
                          className={style.introduction_enterprise_feature_item}
                        >
                          전담 매니저 (CS) 배정
                        </div>
                        <div
                          className={style.introduction_enterprise_feature_item}
                        >
                          보안 강화형 UI 제공
                        </div>
                        <div
                          className={style.introduction_enterprise_feature_item}
                        >
                          ESG 경영 리포트
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={style.contact_list}
              style={
                !isMobile && !isTablet
                  ? { marginBottom: "22px" }
                  : { padding: "12px 22px 32px" }
              }
            >
              <div className={style.contact_item}>
                <div className={style.contact_item_title}>구독 문의</div>
              </div>
              <div className={style.contact_item}>
                <div className={style.contact_item_icon_wrap}>
                  <img
                    alt=""
                    src={
                      !isMobile && !isTablet
                        ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/tel.png`
                        : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/tel_m.png`
                    }
                  />
                </div>
                <div className={style.contact_item_text}>
                  <a href="tel:070-7798-1311">070-7798-1311</a>
                </div>
              </div>
              {!isMobile && !isTablet ? <span /> : null}
              <div className={style.contact_item}>
                <div className={style.contact_item_icon_wrap}>
                  <img
                    alt=""
                    src={
                      !isMobile && !isTablet
                        ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/mail.png`
                        : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/mail_m.png`
                    }
                  />
                </div>
                <div className={style.contact_item_text}>
                  support@riv-tech.co.kr
                </div>
              </div>
            </div>

            <div className={style.launching_promotion_box}>
              <div className={style.launching_promotion_title}>
                런칭 기념 <span>더블 혜택</span> <strong>X2</strong> 프로모션
              </div>
              <div className={style.launching_promotion_benefit_list}>
                <div className={style.launching_promotion_benefit_item}>
                  <div className={style.launching_promotion_benefit_item_box}>
                    <div
                      className={style.launching_promotion_benefit_item_label}
                    >
                      혜택 1
                    </div>
                    <div
                      className={style.launching_promotion_benefit_item_title}
                    >
                      먼저 써보세요, <span>1개월 무료체험!</span>
                    </div>
                  </div>
                  <div className={style.launching_promotion_benefit_item_text}>
                    Wall Pad 연동은 정식 도입 시 이용 가능합니다.
                  </div>
                </div>
                <div className={style.launching_promotion_benefit_item}>
                  <div className={style.launching_promotion_benefit_item_box}>
                    <div
                      className={style.launching_promotion_benefit_item_label}
                    >
                      혜택 2
                    </div>
                    <div
                      className={style.launching_promotion_benefit_item_title}
                    >
                      지금 시작하면, <span>1개월 더! (12+1)</span>
                    </div>
                  </div>
                  <div className={style.launching_promotion_benefit_item_text}>
                    신규 계약 시, 12개월 이용료로 13개월을 이용하세요.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={style.introduce_on_premise_area}>
            <div className={style.introduce_on_premise_title_wrap}>
              <div className={style.introduce_on_premise_title}>구축형</div>
              <div className={style.introduce_on_premise_text}>
                <span>강력한 보안</span>과 <span>완벽한 통합</span>이 필요한
                기업 !{"\n"}
                보안 가이드라인 안에서 구현되는
                {isMobile || isTablet ? "\n" : null} 가장 안전한 공간 관리
                시스템, all Place 구축형
              </div>
            </div>
            <div className={style.introduce_on_premise_feature_list}>
              <div className={style.introduce_on_premise_feature_item_box}>
                <div className={style.introduce_on_premise_feature_icon_wrap}>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/allplace/infra.png`}
                  />
                </div>
                <div className={style.introduce_on_premise_feature_contents}>
                  <div className={style.introduce_on_premise_feature_label}>
                    맞춤형 인프라 구축
                  </div>
                  <div className={style.introduce_on_premise_feature_text}>
                    사내 전산망 또는 폐쇄망 설치가 가능하며, 초기 구축 후 자사
                    인프라 기반으로 안정적으로 운영할 수 있습니다.
                  </div>
                </div>
              </div>
              <div className={style.introduce_on_premise_feature_item_box}>
                <div className={style.introduce_on_premise_feature_icon_wrap}>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/allplace/design.png`}
                  />
                </div>
                <div className={style.introduce_on_premise_feature_contents}>
                  <div className={style.introduce_on_premise_feature_label}>
                    전용 UI/UX 디자인
                  </div>
                  <div className={style.introduce_on_premise_feature_text}>
                    기업 고유의 브랜드 정체성을 반영한 전용 인터페이스 디자인을
                    제공하여 소속감과 사용자 편의성을 높입니다.
                  </div>
                </div>
              </div>
              <div className={style.introduce_on_premise_feature_item_box}>
                <div className={style.introduce_on_premise_feature_icon_wrap}>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/allplace/logic.png`}
                  />
                </div>
                <div className={style.introduce_on_premise_feature_contents}>
                  <div className={style.introduce_on_premise_feature_label}>
                    최적의 커스텀 로직
                  </div>
                  <div className={style.introduce_on_premise_feature_text}>
                    단순 예약을 넘어 기업별 특수한 업무 환경과 보안 정책에 맞춘
                    최적화된 기능을 제안해 드립니다.
                  </div>
                </div>
              </div>
            </div>
            <div
              className={style.contact_list}
              style={!isMobile && !isTablet ? null : { padding: "12px 22px 0" }}
            >
              <div className={style.contact_item}>
                <div className={style.contact_item_title}>구축 문의</div>
              </div>
              <div className={style.contact_item}>
                <div className={style.contact_item_icon_wrap}>
                  <img
                    alt=""
                    src={
                      !isMobile && !isTablet
                        ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/tel.png`
                        : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/tel_m.png`
                    }
                  />
                </div>
                <div className={style.contact_item_text}>
                  <a href="tel:070-7798-1311">070-7798-1311</a>
                </div>
              </div>
              {!isMobile && !isTablet ? <span /> : null}
              <div className={style.contact_item}>
                <div className={style.contact_item_icon_wrap}>
                  <img
                    alt=""
                    src={
                      !isMobile && !isTablet
                        ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/mail.png`
                        : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/mail_m.png`
                    }
                  />
                </div>
                <div className={style.contact_item_text}>
                  support@riv-tech.co.kr
                </div>
              </div>
            </div>
          </div>

          <div
            className={style.contact_area}
            style={{
              backgroundImage:
                !isMobile && !isTablet
                  ? "url('" +
                    process.env.REACT_APP_CLIENT_URL +
                    "img/solution/allplace/contact_bg.png')"
                  : "url('" +
                    process.env.REACT_APP_CLIENT_URL +
                    "img/solution/allplace/contact_bg_m.png')",
            }}
          >
            <div className={style.contact_contents}>
              <div className={style.contact_title}>
                <span>우리 회사에 꼭 맞는 운영 모델</span>을{"\n"}전문가와
                상담하세요.
              </div>
              <div className={style.contact_text}>
                합리적인 고정비의 <span>구독형(Saas)</span> 모델부터,{"\n"}
                보안과 커스텀에 특화된{isMobile ? "\n" : null}
                <span>구축형(On-Premise)</span>
                솔루션까지,{"\n"}
                문의주시면 빠르고 상세한{isMobile ? "\n" : null}안내를
                도와드리겠습니다.
              </div>
            </div>
            <div className={style.contact_list}>
              <div className={style.contact_item}>
                <div className={style.contact_item_icon_wrap}>
                  <img
                    alt=""
                    src={
                      !isMobile && !isTablet
                        ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/tel.png`
                        : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/tel_m.png`
                    }
                  />
                </div>
                <div className={style.contact_item_text}>
                  <a href="tel:070-7798-1311">070-7798-1311</a>
                </div>
              </div>
              {!isMobile && !isTablet ? <span /> : null}
              <div className={style.contact_item}>
                <div className={style.contact_item_icon_wrap}>
                  <img
                    alt=""
                    src={
                      !isMobile && !isTablet
                        ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/mail.png`
                        : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/mail_m.png`
                    }
                  />
                </div>
                <div className={style.contact_item_text}>
                  support@riv-tech.co.kr
                </div>
              </div>
            </div>
          </div>
        </div>

        {props.type === "popup" ? (
          <div style={{ marginBottom: "70px", width: "100%" }}>
            <Consult page="allPlace" />
          </div>
        ) : (
          <div className={style.device_consult_wrapper}>
            <Questions />
          </div>
        )}
      </div>
    </>
  );
}

export default Platform;
